class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close(),
		);
		
		// 点击遮罩背景关闭，但点击购物车内容不关闭
		this.addEventListener("click", (evt) => {
			// 只有点击的是 cart-drawer 本身或 overlay 时才关闭
			// 如果点击目标在 .drawer__inner 内部，则不关闭
			const drawerInner = this.querySelector(".drawer__inner");
			if (!drawerInner.contains(evt.target)) {
				this.close();
			}
		});
		
		this.setHeaderCartIconAccessibility();

		const headerAccount = document.querySelector(".header__account");
		if (headerAccount) {
			headerAccount.addEventListener("click", () => {
				if (this.classList.contains("active")) {
					this.close();
				}
			});
		}

		const search = document.querySelector(".header__search");
		if (search) {
			search.addEventListener("click", () => {
				if (search.isOpen && this.classList.contains("active")) {
					this.close();
				}
			});
		}

		const localization = document.querySelectorAll(".header__localization");
		localization.forEach((localization) => {
			localization.addEventListener("click", () => {
				if (
					localization.querySelector("button[aria-expanded=true]") &&
					this.classList.contains("active")
				) {
					this.close();
				}
			});
		});
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");
		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			if (!this.classList.contains("active")) this.open(cartLink);
			else this.close();
		});
		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				if (!this.classList.contains("active")) this.open(cartLink);
				else this.close();
			}
		});
	}

	open(triggeredBy) {
		const search = document.querySelector(".header__search");
		if (search) {
			search.close();
		}
		const annBar = document.querySelector(".section-announcement");
		if (annBar) annBar.classList.add("section-announcement-overlay");

		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true },
		);

		document.body.classList.add("overflow-hidden-drawer");
	}

	close() {
		const annBar = document.querySelector(".section-announcement");
		if (annBar) annBar.classList.remove("section-announcement-overlay");

		this.classList.remove("active", "animate");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden-drawer");
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id,
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open"),
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector,
			);
		});

		setTimeout(() => {
			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this, false),
			);
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		const sectionId = this.dataset.sectionId;
		return [
			{
				id: sectionId,
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		const sectionId = this.closest('cart-drawer').dataset.sectionId
		return [
			{
				id: 'CartDrawer',
				section: sectionId,
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);


class CartDrawerRecommend extends HTMLElement {
	constructor() {
		super()
		this.onArrowClickListener = this.onArrowClick.bind(this)
	}

	connectedCallback() {
		this.init()
		this.querySelectorAll('.arrow').forEach(btn => {
      btn.addEventListener('click', this.onArrowClickListener)
    })
	}

	disconnectedCallback() {
		this.splide.destroy(true)
		this.querySelectorAll('.arrow').forEach(btn => {
      btn.removeEventListener('click', this.onArrowClickListener)
    })
	}

	init() {
		this.splide = new Splide(this.querySelector('.splide'), {
			perPage: 2,
			gap: 10,
			pagination: false,
			arrows: false,
			padding: {
				right: '18%'
			}
		})
		this.splide.on('ready', this.onSliderReady.bind(this))
		this.splide.on('move', this.onSliderMove.bind(this))
		this.splide.mount()
	}

	onSliderReady() {
    this.updateArrowStates()
  }
  
  onSliderMove() {
    this.updateArrowStates()
  }

	onArrowClick(e) {
    if (e.target.closest('.arrow').classList.contains('arrow-prev')) {
      this.splide.go('<')
    } else {
      this.splide.go('>')
    }
  }

	updateArrowStates() {
    const isLoop = this.splide.options.type == 'loop'
    
		// 处理上一个箭头状态
		const isStart = this.splide.index <= 0;
		const prevDisabled = isStart && !this.splide.options.rewind && !isLoop;
		if (prevDisabled) {
			this.querySelector('.arrow-prev')?.setAttribute('disabled', '')
		} else {
			this.querySelector('.arrow-prev')?.removeAttribute('disabled')
		}
		
		// 处理下一个箭头状态
		const isEnd = this.splide.index >= this.splide.Components.Controller.getEnd();
		const nextDisabled = isEnd && !this.splide.options.rewind && !isLoop;
		if (nextDisabled) {
			this.querySelector('.arrow-next')?.setAttribute('disabled', '')
		} else {
			this.querySelector('.arrow-next')?.removeAttribute('disabled')
		}
  }
} 
customElements.define('cart-drawer-recommend', CartDrawerRecommend);


class CartDrawerPopup extends HTMLElement {
	constructor() {
		super()
		this._showListener = this.show.bind(this)
		this._hideListener = this.hide.bind(this)
	}

	connectedCallback() {
		this.closest('cart-drawer').querySelector(`button[popup="${this.id}"]`)?.addEventListener('click', this._showListener)
		this.querySelector('button[name="close-popup"]')?.addEventListener('click', this._hideListener)
	}

	disconnectedCallback() {
		this.closest('cart-drawer').querySelector(`button[popup="${this.id}"]`)?.removeEventListener('click', this._showListener)
		this.querySelector('button[name="close-popup"]')?.removeEventListener('click', this._hideListener)
	}

	hide() {
		this.removeAttribute('active')
	}

	show() {
		this.setAttribute('active', '')
	}
}
customElements.define('cart-drawer-popup', CartDrawerPopup);

class CartDiscountPopup extends CartDrawerPopup {
  constructor() {
    super();
    this._onSubmitListener = this.onSubmit.bind(this)
    this._onRemoveCodeListener = this.onRemoveCode.bind(this)
  }

  get applyButton() {
    return this.querySelector('.cart-discount__input button')
  }

  get input() {
    return this.querySelector('input[name="code"]')
  }

  get discountCount() {
    const id = this.getAttribute('id')
    return document.querySelector(`[popup="${id}"] .discount-count`)
  }

  connectedCallback() {
    super.connectedCallback();
    this.applyButton?.addEventListener('click', this._onSubmitListener);
    this.querySelectorAll('.applied-code svg').forEach(item => {
      item.addEventListener('click', this._onRemoveCodeListener);
    });
    this.updateDiscountCount()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.applyButton.removeEventListener('click', this._onSubmitListener)
    this.querySelectorAll('.applied-code svg').forEach(item => {
      item.removeEventListener('click', this._onRemoveCodeListener)
    })
  }

  onSubmit() {
    if (this.applyButton.disabled) return
    if (this.input.value) {
      this.applyDiscountCode()
    }
  }

  applyDiscountCode() {
    if (this.applyButton.disabled) return
		this.applyButton.setAttribute('aria-disabled', true);
		this.applyButton.classList.add('loading');
		this.applyButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    this.applyButton.disabled = true

    const codes = []
    const newCode = this.input.value
    if (newCode) {
      codes.push(newCode)
    }
    this.querySelectorAll('.applied-code').forEach(item => {
      codes.push(item.dataset.code)
    })

    const cartDrawer = this.closest('cart-drawer');
    const sectionsToRender = cartDrawer.getSectionsToRender();
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        discount: codes.join(','),
        sections: sectionsToRender.map(section => section.id),
        sections_url: window.location.pathname
      })
    })
    .then(res => res.json())
    .then(data => {
      cartDrawer.renderContents(data);
    })
    .finally(() => {
      this.applyButton.setAttribute('aria-disabled', false);
			this.applyButton.classList.remove('loading');
			this.applyButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
			this.applyButton.disabled = false
    })
  }

  onRemoveCode(e) {
    if (this.applyButton.disabled) return
    e.target.closest('.applied-code').remove()
    this.applyDiscountCode()
  }

  updateDiscountCount() {
    const count = this.querySelectorAll('.applied-code').length
    this.discountCount.textContent = count == 0 ? '' : count + ''
  }
};
customElements.define('cart-discount-popup', CartDiscountPopup)